import {
  Buyouts,
} from '../api'
import { BuyoutV2 } from "../api-v2"
import { BuyoutMapper } from "../api-v2/mappings"
import { ApiVersionDelagator } from "./api-delegator"
/**
 * @typedef {import('../api-v2/js-doc').V1BatchCreateBuyoutsRequest} V1BatchCreateBuyoutsRequest
 * @typedef {import('../api-v2/js-doc').V2CreateInvoiceDocumentRequest} V2CreateInvoiceDocumentRequest
 * @typedef {import('../api-v2/js-doc').V2MappingOptions} V2MappingOptions
 */

export class BuyoutApiDelegator extends ApiVersionDelagator {
  /**
   * @param {V1BatchCreateBuyoutsRequest} v1Request - V1 batch create buyouts
   * @returns {Promise<void>}
   */
  async batchCreate (v1Request) {
    return await this.runWriteApiCalls(
      '',
      v1Request,
      this.#postBatchCreateBuyoutsV1.bind(this),
      this.#postBatchCreateBuyoutsV2.bind(this),
      {
        operationName: 'post-invoice',
      }
    )
  }

  /**
   * @param {V1BatchCreateBuyoutsRequest} payload - V1 create invoice request body
   * @returns {Promise<void>}
   */
  async #postBatchCreateBuyoutsV1 (payload) {
    await Buyouts.create(payload)
  }

  /**
   * @param {V2MappingOptions} _v2MappingOptions - V2 mapping options
   * @param {V1BatchCreateBuyoutsRequest} v1Request - V1 create invoice request body
   * @param {any=} _v1Response - V1 create invoice response body
   * @returns {Promise<void>}
   */
  // eslint-disable-next-line no-unused-vars
  async #postBatchCreateBuyoutsV2 (_v2MappingOptions, v1Request, _v1Response) {
    const v2Request = BuyoutMapper.v1BatchCreateToV2(v1Request)
    await new BuyoutV2().create(v2Request)
  }
}
